import { concat } from '@ember/helper';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import BaseAntecedentsFields from '../base-antecedents-fields';
interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient?: unknown;
  };
}

export default class MyComponent extends Component<Signature> {
  BaseAntecedentsFields = BaseAntecedentsFields;

  <template>
    <this.BaseAntecedentsFields
      @form={{@form}}
      @patient={{@patient}}
      as |familyMembers|
    >

      <h4 class='ui header'>Mutations génétiques</h4>

      <div class='field'>
        <@form.ConditionalRadioGroup
          @conditionalValue={{true}}
          @propertyName='brca1'
          as |ConditionalRadioGroup showConditionalBlock|
        >
          <div class='field'>
            <ConditionalRadioGroup.AlignedFieldsRadioGroup
              @title='BRCA 1'
              as |Group|
            >
              <Group.FieldRadio @label='Oui' @value={{true}} />
              <Group.FieldRadio @label='Non' @value={{false}} />
            </ConditionalRadioGroup.AlignedFieldsRadioGroup>
          </div>

          {{#if showConditionalBlock}}
            <div class='field'>
              <@form.Dropdown
                @propertyName='brca1Member'
                @multipleSelection={{true}}
                as |dropdown|
              >
                {{#each familyMembers as |familyMember|}}
                  <dropdown.Item
                    @key={{familyMember}}
                    @value={{t (concat 'family.' familyMember)}}
                  />
                {{/each}}
              </@form.Dropdown>
            </div>
          {{/if}}

        </@form.ConditionalRadioGroup>
      </div>

      <div class='field'>
        <@form.ConditionalRadioGroup
          @conditionalValue={{true}}
          @propertyName='brca2'
          as |ConditionalRadioGroup showConditionalBlock|
        >
          <div class='field'>
            <ConditionalRadioGroup.AlignedFieldsRadioGroup
              @title='BRCA 2'
              as |Group|
            >
              <Group.FieldRadio @label='Oui' @value={{true}} />
              <Group.FieldRadio @label='Non' @value={{false}} />
            </ConditionalRadioGroup.AlignedFieldsRadioGroup>
          </div>

          {{#if showConditionalBlock}}
            <div class='field'>
              <@form.Dropdown
                @propertyName='brca2Member'
                @multipleSelection={{true}}
                as |dropdown|
              >
                {{#each familyMembers as |familyMember|}}
                  <dropdown.Item
                    @key={{familyMember}}
                    @value={{t (concat 'family.' familyMember)}}
                  />
                {{/each}}
              </@form.Dropdown>
            </div>
          {{/if}}

        </@form.ConditionalRadioGroup>
      </div>

      <h4 class='ui header'>Antécédents familiaux</h4>

      <div class='field'>
        <@form.ConditionalRadioGroup
          @conditionalValue={{true}}
          @propertyName='familyHistoryBreastCancer'
          as |ConditionalRadioGroup showConditionalBlock|
        >
          <div class='field'>
            <ConditionalRadioGroup.AlignedFieldsRadioGroup
              @title='Cancer du sein'
              as |Group|
            >
              <Group.FieldRadio @label='Oui' @value={{true}} />
              <Group.FieldRadio @label='Non' @value={{false}} />
            </ConditionalRadioGroup.AlignedFieldsRadioGroup>
          </div>

          {{#if showConditionalBlock}}
            <div class='field'>
              <@form.Dropdown
                @propertyName='familyHistoryBreastCancerMember'
                @multipleSelection={{true}}
                as |dropdown|
              >
                {{#each familyMembers as |familyMember|}}
                  <dropdown.Item
                    @key={{familyMember}}
                    @value={{t (concat 'family.' familyMember)}}
                  />
                {{/each}}
              </@form.Dropdown>
            </div>
          {{/if}}

        </@form.ConditionalRadioGroup>
      </div>

      <div class='field'>
        <@form.ConditionalRadioGroup
          @conditionalValue={{true}}
          @propertyName='familyHistoryOvarianCancer'
          as |ConditionalRadioGroup showConditionalBlock|
        >
          <div class='field'>
            <ConditionalRadioGroup.AlignedFieldsRadioGroup
              @title='Cancer des ovaires'
              as |Group|
            >
              <Group.FieldRadio @label='Oui' @value={{true}} />
              <Group.FieldRadio @label='Non' @value={{false}} />
            </ConditionalRadioGroup.AlignedFieldsRadioGroup>
          </div>

          {{#if showConditionalBlock}}
            <div class='field'>
              <@form.Dropdown
                @propertyName='familyHistoryOvarianCancerMember'
                @multipleSelection={{true}}
                as |dropdown|
              >
                {{#each familyMembers as |familyMember|}}
                  <dropdown.Item
                    @key={{familyMember}}
                    @value={{t (concat 'family.' familyMember)}}
                  />
                {{/each}}
              </@form.Dropdown>
            </div>
          {{/if}}

        </@form.ConditionalRadioGroup>
      </div>

    </this.BaseAntecedentsFields>
  </template>
}
